<div
  class="pia-loading-overlay"
  *ngIf="visibility"
  [ngClass]="{ 'child-mode': childMode }"
>
  <div class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
  </div>
</div>
